exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adStatusLabel__statusWrapper___Evcx9 {\n  border-radius: 4px;\n  background: white;\n  padding: 4px 8px;\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  gap: 4px;\n  font-size: 12px; }\n\n.adStatusLabel__statusCircle___3ukAa {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%; }\n\n.adStatusLabel__activeLabel___1eKVB {\n  background-color: #16c7a5; }\n\n.adStatusLabel__pausedLabel___13Yus {\n  background-color: #828282; }\n\n.adStatusLabel__soldLabel___13Fj9 {\n  background-color: #a79265; }\n\n.adStatusLabel__expiredLabel___ct06s {\n  background-color: #f94144; }\n\n.adStatusLabel__pendingLabel___ZmKd8 {\n  background-color: #828282; }\n", ""]);

// exports
exports.locals = {
	"statusWrapper": "adStatusLabel__statusWrapper___Evcx9",
	"statusCircle": "adStatusLabel__statusCircle___3ukAa",
	"activeLabel": "adStatusLabel__activeLabel___1eKVB",
	"pausedLabel": "adStatusLabel__pausedLabel___13Yus",
	"soldLabel": "adStatusLabel__soldLabel___13Fj9",
	"expiredLabel": "adStatusLabel__expiredLabel___ct06s",
	"pendingLabel": "adStatusLabel__pendingLabel___ZmKd8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/MyAdsPage/MyAds/MyAdsCard/AdStatusLabel/adStatusLabel.scss
// module id = 4962
// module chunks = 6